import React from 'react';
import './about.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faRocket,
  faBullseye,
  faHandshake,
  faStar,
  faBuilding,
  faEye,
} from '@fortawesome/free-solid-svg-icons';

const ABOUT = () => {
  // Données de l'équipe
  /*const teamMembers = [
    {
      id: 1,
      name: "Jean Dupont",
      role: "Directeur Général & Fondateur",
      expertise: "Stratégie digitale & Transformation",
      experience: "20+ ans d'expérience",
      description: "Expert en stratégie digitale avec un parcours chez plusieurs leaders technologiques.",
      image: "images/7.jpg"
    },
    {
      id: 2,
      name: "Marie Laurent",
      role: "Directrice Technique",
      expertise: "Architecture Cloud & DevOps",
      experience: "15 ans d'expérience",
      description: "Spécialiste en infrastructure cloud et optimisation des performances.",
      image: "images/2.jpeg"
    },
    {
      id: 3,
      name: "Thomas Martin",
      role: "Lead Développeur",
      expertise: "Intelligence Artificielle & Machine Learning",
      experience: "12 ans d'expérience",
      description: "Expert en solutions d'IA et algorithmes de machine learning.",
      image: "images/6.jpg"
    },
    {
      id: 4,
      name: "Sophie Bernard",
      role: "Cheffe de Projet",
      expertise: "Gestion de projets IT & Agile",
      experience: "10 ans d'expérience",
      description: "Certifiée PMP et Scrum Master, elle assure le succès de vos projets.",
      image: "images/2.jpeg"
    }
  ];*/

  // Valeurs de l'entreprise
  const companyValues = [
    {
      id: 1,
      title: "Innovation Continue",
      description: "Nous repoussons constamment les limites technologiques pour offrir des solutions d'avant-garde.",
      icon: faRocket // 🚀
    },
    {
      id: 2,
      title: "Excellence Technique",
      description: "Nos experts maintiennent les plus hauts standards de qualité et de performance.",
      icon: faBullseye // 🎯
    },
    {
      id: 3,
      title: "Approche Client",
      description: "Chaque solution est conçue sur mesure pour répondre précisément à vos besoins.",
      icon: faHandshake // 🤝
    },
    {
      id: 4,
      title: "Éthique & Transparence",
      description: "Nous opérons avec intégrité et transparence dans toutes nos relations.",
      icon: faStar // ✨
    }
  ];

  // Certifications
  const certifications = [
    { 
      id: 1, 
      image: "/images/17.jpg",
      
    },
    { 
      id: 2, 
      image: "/images/18.png",
     
    },
    { 
      id: 3, 
      image: "/images/9.png",
      
    },
    { 
      id: 4, 
      image: "/images/20.png",
      
    },
  ];

  return (
    <section id="apropos" className="about-section">
      <div className="container">
        {/* En-tête */}
        <div className="about-header">
          <div className="section-badge">
            <span className="badge-text">NOTRE HISTOIRE</span>
          </div>
          
          <h2 className="section-title">
            <span className="title-line">À propos de</span>
            <span className="title-line highlight">MOSE RAI GC</span>
          </h2>
          
        </div>

        {/* Section Notre Histoire */}
        <div className="our-story">
          <div className="story-content">
            <h3 className="story-title">Notre Histoire</h3>
            
            <div className="story-text">
              <p>
                Fondée en 2021, <strong>MOSE RAI GC</strong> est née d'une vision simple mais ambitieuse : vulgariser 
                l'accès aux technologies de pointe pour les entreprises de toutes tailles.
              </p>
              
              <p>
                De nos premiers pas modeste à Abidjan, nous avons grandi pour devenir un partenaire stratégique
               de référence dans la transformation digitale, accompagnant plus d'une dizaines d'entreprises dans leur révolution numérique.
              </p>
              
              <p>
                Aujourd'hui, notre équipe d'experts passionnés continue d'innover et de repousser les limites 
                technologiques pour créer un impact durable chez nos clients.
              </p>
            </div>
            
           
          </div>
          
          {/* Image illustrative - À DÉCOMMENTER */}
          <div className="story-image">
           
            <img src="/images/8.jpg" alt="Client3" className="story-img" /> 
              
            
            <div className="image-placeholder">
              <div className="placeholder-content">
                <FontAwesomeIcon icon={faBuilding} className="placeholder-icon" />
                <p className="placeholder-text">
                  Nos bureaux
                  <br />
                  <small>Paris, France</small>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section Notre Mission */}
        <div className="our-mission">
          <div className="mission-card">
            <FontAwesomeIcon icon={faBullseye} className="mission-icon" />
            <h3 className="mission-title">Notre Mission</h3>
            <p className="mission-text">
              Accompagner les entreprises dans leur transformation digitale en leur fournissant des solutions 
              innovantes, sur mesure et pérennes qui accélèrent leur croissance et renforcent leur compétitivité.
            </p>
          </div>
          
          <div className="mission-card">
            <FontAwesomeIcon icon={faEye} className="mission-icon" />
            <h3 className="mission-title">Notre Vision</h3>
            <p className="mission-text">
              Devenir une multinationale africaine de référence, reconnue pour transformer les traditions en solutions 
              modernes, alliant technologies innovantes, services polyvalents et excellence opérationnelle au service du monde.
            </p>
          </div>
        </div>

        {/* Section Nos Valeurs */}
        <div className="our-values">
          <div className="values-header">
            <h3 className="values-title">Nos Valeurs Fondamentales</h3>
            <p className="values-subtitle">
              Ces principes guident chacune de nos actions et décisions au quotidien.
            </p>
          </div>
          
          <div className="values-grid">
            {companyValues.map(value => (
              <div key={value.id} className="value-card">
                <FontAwesomeIcon icon={value.icon} className="value-icon" />
                <h4 className="value-card-title">{value.title}</h4>
                <p className="value-card-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Section Notre Équipe */}
        {/*<div className="our-team">
          <div className="team-header">
            <h3 className="team-title">Rencontrez Notre Équipe</h3>
            <p className="team-subtitle">
              Des experts passionnés dédiés à la réussite de vos projets.
            </p>
          </div>
          
          <div className="team-grid">
            {teamMembers.map(member => (
              <div key={member.id} className="team-member">
                <div className="member-photo">
                  
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="member-img"
                    />
                  ) : (
                    <div className="member-placeholder">
                      <span className="member-initial">{member.name.charAt(0)}</span>
                    </div>
                  )}
                  
                  <div className="member-overlay">
                    <span className="overlay-experience">{member.experience}</span>
                  </div>
                </div>
                
                <div className="member-info">
                  <h4 className="member-name">{member.name}</h4>
                  <p className="member-role">{member.role}</p>
                  <p className="member-expertise">{member.expertise}</p>
                  <p className="member-description">{member.description}</p>
                  
                </div>
              </div>
            ))}
          </div>
        </div>*/}

        {/* Section Certifications */}
        <div className="our-certifications">
          <div className="certifications-header">
            <h3 className="certifications-title">Nos Clients & Partenariats</h3>
            <p className="certifications-subtitle">
              Des clients qui nous font confiance, ce qui témoignent de notre expertise et de notre engagement de qualité.
            </p>
          </div>
          
          <div className="certifications-grid">
            {certifications.map(cert => (
              <div key={cert.id} className="certification-card">
                <img 
        src={cert.image} 
        alt={cert.alt} 
        className="certification-image"
      />
              </div>
            ))}
          </div>
        </div>

        
      </div>
    </section>
  );
};

export default ABOUT;